<template>
    <div>
        <div class="group-head">
            <div class="title"><span class="el-icon-data-line"></span> 每日</div>
        </div>
        <el-tabs class="MT10" v-model="tabVal" @tab-click="drawChart()">
            <el-tab-pane name="1" label="乐迷新增">
            </el-tab-pane>
            <el-tab-pane name="2" label="B类新增">
            </el-tab-pane>
            <el-tab-pane name="3" label="用户活跃">
            </el-tab-pane>
        </el-tabs>		
		<div class="MT10" v-if="tabVal == 3">
			<el-tabs class="MT10" v-model="activeVal" @tab-click="drawChart()">
			    <el-tab-pane name="1" label="日活跃">
			    </el-tab-pane>
			    <el-tab-pane name="2" label="周活跃">
			    </el-tab-pane>
			    <el-tab-pane name="3" label="月活跃">
			    </el-tab-pane>
			</el-tabs>
		</div>		
        <div class="content MT20" v-loading="dataLoading">			
           <div id="chartContainer2" ref="chartContainer2"></div>
        </div>
		<div class="MB50"><router-link class="color-theme" :to="`/report/fans/loginFans?rangeStart=${daterange[0]} 00:00:00&rangeEnd=${daterange[1]} 23:59:59`" v-if="tabVal ==3">查看详情</router-link></div>
    </div>
</template>

<script>
import { Chart } from '@antv/g2';
export default {
    props:{
        daterange: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return {
            data: [],
            dataLoading: false,
            tabVal: "1",
			activeVal:"1",
			chart:null,
			dayData:[],
			weekData:[],
			monthData:[]
        }
    },
    mounted(){
        this.getData();
    },
    watch:{
        daterange(v1,v2){
			
            if(v2.length > 0 && v1 != v2){
				
                this.getData();
				
				
            }
        }
    },
    methods:{
        getData(){
            this.dataLoading = true;
            this.$request({
                url: "/dashboard/newUser",
                method: "POST",
                data: {
                    start: this.daterange.length > 0 ? this.daterange[0]: "",
                    end: this.daterange.length > 1 ? this.daterange[1]: "",
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result || [];
						
						this.dayData = result.loginFansLineData.day
						this.weekData = result.loginFansLineData.week
						this.monthData = result.loginFansLineData.month						
						
                        this.$nextTick(() => {
                            this.drawChart();
                        })
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        drawChart(){
            if( this.chart ) this.chart.destroy();
            
            let _data = [];
            if( this.tabVal == "1"  ){
                _data = [...this.data.userLineSeriesData]
            }else if( this.tabVal == "2" ){
                _data = [...this.data.buserLineSeriesData]
				
            }else if( this.tabVal == "3" && this.activeVal == "1" && this.dayData ){
                _data = [...this.dayData]
            }
			else if( this.tabVal == "3" && this.activeVal == "2" && this.weekData ){
			    _data = [...this.weekData]
			}
			else if( this.tabVal == "3" && this.activeVal == "3" && this.monthData ){
			    _data = [...this.monthData]
			}
            _data.map(v => {
                v.value = parseFloat(v.value)
            })

            this.chart = new Chart({
                container: 'chartContainer2',
                autoFit: true,
                height: 300,
            });
            this.chart.data(_data);

            this.chart.tooltip({
                showTitle: false,
                showMarkers: false,
                showCrosshairs: true,
                itemTpl: '<div><div class="g2-tooltip-title" style="font-size:14px;font-weight:700;">{name}：{value}</div><ul class="g2-tooltip-list">{rank}</ul></div>',
            });
            
            if( _data.length > 30 ){
                this.chart.option('slider', {
                    start: (_data.length - 30) / _data.length,
                    end: 1,
                });
            }
            this.chart
                .line()
                .position('name*value')
                .shape('smooth')
                .tooltip('name*value*rank', (name,value,rank) => {
                    
                    let _rank = "", _keys = Object.keys(rank);
                    _keys.map(v => {
                        _rank += `<li class="g2-tooltip-list-item"><span class="g2-tooltip-name">${v}</span>：<span class="g2-tooltip-value">${rank[v]}</span></li>`
                    })

                    return {
                        name: name,
                        value: value,
                        rank: _rank
                    };
                });

            this.chart.render();
            
        }
    }
}
</script>

<style lang="scss" scoped>
.MB50{
	margin-bottom: 50px;
}
</style>